import React, { useEffect } from "react";
//GraphQL
import { useMutation, gql } from "@apollo/client";
//Router
import { useParams } from "react-router-dom";

const ReclamationReady = ({ setFrameTarjet }) => {
  setFrameTarjet("reclamations-to-print");

  const { id } = useParams();

  const getMutation = () => {

    return gql`
    mutation updateOrderReclamation{
      updateOrderReclamation(id: ${parseInt(id)}, isReclamation: true) {
          id
        }
      }
  `;
  };
  // eslint-disable-next-line
  const [executeMutation, { data, error }] = useMutation(getMutation());

  useEffect(() => {
    executeMutation();
    // eslint-disable-next-line
  }, []);
  return <></>;
};

export default ReclamationReady;
